import React, { useState } from 'react';
import { Grid2, TextField, Button, Typography, InputAdornment } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import useNotify from '../../../hooks/useNotify';

function DynamicPricingForm({ values }) {
    const { t } = useTranslation();
    const { notifyError, notifySuccess } = useNotify();
    const [copyingField, setCopyingField] = useState(null);

    const copyToClipboard = async (text, fieldName) => {
        if (!text) return;
        setCopyingField(fieldName);
        try {
            await navigator.clipboard.writeText(text);
            notifySuccess(t('common.copiedToClipboard'));
        } catch (err) {
            notifyError(err);
        } finally {
            setCopyingField(null);
        }
    };

    return (
        <>
            <Grid2 size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    label={t('integrations.dynamicPricing.apiKey')}
                    value={values.settings?.apiKey || ''}
                    InputProps={{
                        readOnly: true,
                        endAdornment: values.settings?.apiKey ? (
                            <InputAdornment position="end">
                                <Button
                                    size="small"
                                    variant="text"
                                    onClick={() =>
                                        copyToClipboard(values.settings.apiKey, 'apiKey')
                                    }
                                    disabled={copyingField === 'apiKey'}
                                >
                                    <ContentCopy fontSize="small" />
                                </Button>
                            </InputAdornment>
                        ) : null,
                    }}
                    placeholder={t('integrations.dynamicPricing.enableToGenerate')}
                />
            </Grid2>
            <Grid2 size={{ xs: 12 }} sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary">
                    {t('integrations.dynamicPricing.description')}
                </Typography>
            </Grid2>
        </>
    );
}

export default DynamicPricingForm;
